import React, { useState, useEffect } from "react"
import Icon from "../../../components/AppIcon"
import { Card } from "../../../components/ui/card"
import { Badge } from "../../../components/ui/badge"
import { getProgramCertificates } from "../../../utils/programDetailHelpers"

const ProgramCredentialsTab = ({ orgId, courseIds }) => {
  const [certificates, setCertificates] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    getProgramCertificates(orgId, courseIds || []).then(({ certificates: list }) => {
      setCertificates(list || [])
      setLoading(false)
    })
  }, [orgId, courseIds])

  if (loading) return <div className="p-8 text-center text-sm text-muted-foreground">Loading credentials...</div>

  if (certificates?.length === 0) {
    return (
      <Card className="p-12 text-center dark:bg-transparent">
        <Icon name="Award" size={24} className="text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">No credentials issued across this program's courses yet.</p>
      </Card>
    )
  }

  return (
    <Card className="p-0 dark:bg-transparent overflow-hidden">
      <div className="divide-y divide-border">
        {certificates?.map((cert) => (
          <div key={cert?.certId} className="flex items-center gap-4 px-4 py-3">
            <div className="w-9 h-9 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
              <Icon name="Award" size={15} className="text-accent" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground truncate">{cert?.issuedTo}</p>
              <p className="text-xs text-muted-foreground truncate">{cert?.courseTitle}</p>
            </div>
            <Badge variant={cert?.status === "valid" ? "success" : "destructive"} className="shrink-0">
              {cert?.status === "valid" ? "Valid" : "Revoked"}
            </Badge>
          </div>
        ))}
      </div>
    </Card>
  )
}

export default ProgramCredentialsTab